// The ObservationImageSet InputType now routes through the ObservationCardDeck template and provider.
// The CardDeck's patchedConfiguration.ObservationImageSet applies the correct settings
// (useObservationSet: true, filters for 'Legacy Image' type) automatically when this InputType is detected.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationImageSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationImageSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationImageSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationImageSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationImageSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationImageSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
